export const config = window.config;
